<template>
    <v-data-table v-bind="{ items, headers }" dense hide-default-footer disable-sort disable-filtering disable-pagination no-data-text="등록된 내용이 없습니다" mobile-breakpoint="1024">
        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>
    </v-data-table>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/variables";

const headers = initDataTableHeaders(
    [
        { text: "생산기종", value: "MODEL_CODE" },
        { text: "품명/품번", value: "MODEL_NAME" },
        { text: "생산/실생산", value: "QTY", width: 160, align: "center" },
        { text: "누계수", value: "MINUS_QTY", width: 160, align: "center" },
        { text: "달성율", value: "PROD_RATE", width: 160, align: "center" },
        { text: "가동률", value: "RUN_RATE", width: 160, align: "center" },
    ],
    {
        showsDivider: true,
        className: "font-size-14",
        cellClass: "font-size-14",
    }
);

export default {
    props: {
        process: { type: String },
        planDate: { type: String },
    },
    data: () => ({
        head: [],
        limit: 0,
        summary: { totalCount: 0 },

        loading: false,
        headers,
    }),
    computed: {
        items() {
            return this.head.map((item, index) => ({ ...(item || {}), index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        params() {
            let { ...query } = this.$route.query;

            delete query.page;

            query.process = this.process;
            query.planDate = this.planDate;

            return { ...query };
        },
    },
    mounted() {
        this.search();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async search() {
            if (!this.process || !this.planDate) return;

            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, head } = await api.console.mes.reports.head.gets({
                    headers: { skip, limit },
                    ...params,
                });

                this.summary = summary;
                this.head = head;
            } finally {
                if (this.loading) this.loading = false;
            }
        },
    },
};
</script>

<style></style>
